<span class="setting-item" [ngClass]="styleClasses">
  <span class="start-desciption" *ngIf="startDescription" [innerHTML]="startDescription"></span>
  <ng-content></ng-content>
  <span class="end-desciption" *ngIf="endDesciption" [innerHTML]="endDesciption" ></span>
</span>
